import { useState } from "react";

import image from "../../Assets/lipana/lipana-payment.png";
import image2 from "../../Assets/lipana/lipana-verify.png";
import image3 from "../../Assets/lipana/lipana-support.png";

import Courasel from "../Courasel/Courasel";
import { Link } from "react-router-dom";
import { lipana_signup } from "../../Config/redirect_url";

const Choices = () => {
  const advantages = [
    {
      image: image,
      title: "Simple,Secure, Reliable.",
      text: "Make payments easier for your customers with online invoices they can pay with their MPESA, Card or Crypto payments.",
    },
    {
      image: image2,
      title: "Smooth onboarding",
      text: "Make payments easier for your customers with online invoices they can pay with their MPESA, Card or Crypto payments.",
    },
    {
      image: image3,
      title: "24/7 Full time Support",
      text: "We still believe in speaking to humans any time that’s why we offer 24/7 Live support from our website and application.",
    },
  ];

  const [index, setCurrentIndex] = useState(0);
  const getCurrentIndex = (num) => {
    setCurrentIndex(num);
  };

  return (
    <div className="flex flex-col-reverse mt-16 bg-white p-4 rounded-[20px] shadow-[0px 4px 4px rgba(0, 0, 0, 0.1)] md:rounded-[40px] md:py-16 md:px-10 lg:px-24 lg:flex-row">
      {/* For Desktop */}
      <div className="hidden space-y-10 md:block lg:w-1/2">
        <div className="space-y-12 w-full">
          {advantages.map((advantage, i) => (
            <div
              key={i}
              className={`${
                index === advantages.indexOf(advantage)
                  ? `border-l-4 border-brandColor text-blackColor`
                  : `text-gray-500`
              } cursor-pointer space-y-2  px-6 rounded-[0.3rem]`}
            >
              <h3
                className={`${
                  index === advantages.indexOf(advantage)
                    ? `text-brandColor`
                    : ` `
                } text-2xl font-semibold`}
              >
                {advantage.title}
              </h3>
              <p>{advantage.text}</p>
            </div>
          ))}
        </div>
        <Link to={lipana_signup()}>
        <button className="mt-5 border bg-brandColor text-white py-3 px-16 rounded-full font-semibold">
          Get Started
        </button>
        </Link>
      </div>

      {/* For Mobile */}
      <div className="block md:hidden">
        <Courasel
          direction="X"
          flex="row"
          duration="100"
          delay={5000}
          arrows="hidden"
          getIndex={getCurrentIndex}
        >
          {advantages.map((advantage, i) => (
            <div
              key={i}
              className={`w-full min-w-full ${
                index === advantages.indexOf(advantage)
                  ? `text-blackColor`
                  : `text-gray-500`
              } cursor-pointer space-y-2 rounded-[0.3rem]`}
            >
              <h3
                className={`${
                  index === advantages.indexOf(advantage)
                    ? `text-brandColor`
                    : ` `
                } text-2xl font-semibold`}
              >
                {advantage.title}
              </h3>
              <p>{advantage.text}</p>
            </div>
          ))}
        </Courasel>

        <div className="flex flex-row justify-center gap-4 mt-5 lg:hidden">
          {advantages.map((child, i) => (
            <p
              className={`cursor-pointer rounded-full duration-500 px-3 py-[6px] ${
                advantages.indexOf(child) === index
                  ? `bg-brandColor px-6`
                  : `bg-transparent border`
              }`}
              key={i}
            ></p>
          ))}
        </div>

        {/* CTA for mobile */}
        <Link to={lipana_signup()}>
        <button className="block w-full border bg-brandColor mt-8 text-white py-3 px-16 rounded-full font-semibold md:hidden">
          Get Started
        </button>
        </Link>
      </div>

      <div className="text-center space-y-5 mb-3 lg:w-1/2">
        <div className=" hidden mx-auto lg:block lg:w-3/4">
          <Courasel
            direction="X"
            flex="row"
            duration="0"
            delay={5000}
            arrows="flex"
            getIndex={getCurrentIndex}
          >
            {advantages.map((advantage, i) => (
              <img
                key={i}
                src={advantage.image}
                alt="mockup"
                className="rounded-[20px] object-cover w-full min-w-full mx-auto md:rounded-auto lg:object-contain lg:h-full"
              />
            ))}
          </Courasel>
        </div>

        {/*For mobile view */}
        <div className="w-full mx-auto lg:hidden">
          <Courasel
            direction="X"
            flex="row"
            duration="0"
            delay={5000}
            arrows="hidden"
            getIndex={getCurrentIndex}
          >
            {advantages.map((advantage, i) => (
              <img
                key={i}
                src={advantage.image}
                alt="mockup"
                className="h-64 rounded-[20px] object-cover w-full min-w-full mx-auto md:rounded-auto md:object-cover md:h-96"
              />
            ))}
          </Courasel>
        </div>
      </div>
    </div>
  );
};

export default Choices;
